import React from 'react';
import { SvgWithColorProps } from '../interfaces';

const SVGCardPaper = ({ color }: SvgWithColorProps) => (
  <svg
    width='34'
    height='48'
    viewBox='0 0 34 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M31.2013 13.875H27.0782V7.37449L25.1365 5.45612H20.9314V2.42832L18.9897 0.509949H14.387L12.4395 2.42832V6.60599H8.23441L6.28687 8.52436V19.6532L5.74881 19.1216H2.08182L0.134277 21.04V36.7857L11.0358 47.0305H22.645L33.1489 37.2364V15.7934L31.2013 13.875ZM30.8095 36.2426L21.7151 44.7192H11.9716L2.47366 35.7976V21.9992L3.04681 21.4329H4.77796L6.28687 22.9237V30.3777H8.62625V9.48355L9.1994 8.91728H11.8663L12.4395 9.48355V26.6276H14.7788V3.38751L15.352 2.82124H18.0189L18.592 3.38751V26.6276H20.9314V8.3279L21.5046 7.76164H24.1715L24.7446 8.3279V26.6276H27.084V16.7526L27.6572 16.1863H30.2363L30.8095 16.7526V36.2426Z'
      fill={color}
    />
  </svg>
);

export default SVGCardPaper;
